import { Field } from "formik";
import React from "react";
import { CardBody, Input } from "../../../../../_metronic/_partials/controls";

export default function OrganizationDetailForm({ setFieldValue }) {
  return (
    <>
      <CardBody>
        <div className="form-group row">
          <div className="col-lg-4 col-md-4">
            <Field
              name="domain_name"
              placeholder="Nama Domain"
              label="Nama Domain"
              component={Input}
              disabled={true}
            />
          </div>
        </div>
        <div className="form-group row">
          <div className="col">
            <Field
              name="name"
              placeholder="Nama Lembaga"
              label="Nama Lembaga"
              component={Input}
              onChange={e => setFieldValue(e.target.name, e.target.value)}
            />
          </div>
          <div className="col">
            <Field
              name="user.name"
              placeholder="Nama PIC"
              label="Nama PIC"
              component={Input}
              onChange={e => setFieldValue(e.target.name, e.target.value)}
            />
          </div>
          <div className="col">
            <Field
              name="call_center"
              placeholder="Hp PIC"
              label="Hp PIC"
              component={Input}
              onChange={e => setFieldValue(e.target.name, e.target.value)}
            />
          </div>
        </div>
      </CardBody>
    </>
  );
}
